/**
 * Mainbeauty — popup xem bộ ảnh bằng lightGallery ở chế độ dynamic. Dữ liệu ảnh do PHP dựng
 * (pi_gallery_items() trong inc/mainbt-helpers.php), hai cách gắn:
 *   [data-pi-gallery="<json>"]           mỗi nút mang cả bộ, mở từ ảnh đầu
 *   [data-pi-gallery-set="<json>"] chứa [data-pi-gallery-open="<i>"]
 *                                        bộ khai MỘT lần ở khối, mỗi ảnh mở đúng từ vị trí của nó
 */
import "lightgallery";
import "lightgallery/modules/lg-thumbnail.js";

function openGallery($el, json, index) {
	let items;
	try {
		items = JSON.parse(json);
	} catch (err) {
		return;
	}
	if (!Array.isArray(items) || !items.length) {
		return;
	}

	$el.lightGallery({
		dynamic: true,
		dynamicEl: items,
		index: index >= 0 && index < items.length ? index : 0,
		download: false,
		counter: items.length > 1,
		thumbnail: items.length > 1,
		share: false,
		escKey: true,
	});

	// Chế độ dynamic không tự dọn: không huỷ thì lần bấm sau chỉ gọi lại init() trên bộ ảnh cũ.
	$el.one("onCloseAfter.lg", function () {
		const lg = $el.data("lightGallery");
		if (lg) {
			lg.destroy(true);
		}
	});
}

// Uỷ quyền từ document: Owl nhân bản slide khi loop, thẻ bản sao không mang theo instance nào
// nên bind trực tiếp lên phần tử sẽ chết ở đúng những slide người dùng kéo tới.
$(document).on("click", "[data-pi-gallery]", function (e) {
	e.preventDefault();
	openGallery($(this), this.dataset.piGallery, 0);
});

$(document).on("click", "[data-pi-gallery-open]", function (e) {
	const set = this.closest("[data-pi-gallery-set]");
	if (!set) {
		return;
	}
	e.preventDefault();
	openGallery($(this), set.dataset.piGallerySet, parseInt(this.dataset.piGalleryOpen, 10) || 0);
});
